import { API_AUTH, setTokenGlobal } from "../common";
import { Cookies } from "react-cookie";
import { getDomain } from "utils/utils";

var urlNew = getDomain();
const cookies = new Cookies();
var token = cookies.get("userTokenDaiLy");
if (typeof token != "undefined" && token.length > 6) {
  token = token.substring(6);
  setTokenGlobal(token, urlNew);
}
export default {
  getDanhMucAttributes: (params) =>
    API_AUTH.get("danhmucAttributes/getDanhMucAttributes", params),
  addAttributes: (params) =>
    API_AUTH.get(
      "danhmucAttributes/addAttributes?Name=" +
      params.Name +
      "&Display=" +
      params.Display
    ),
};
